jQuery(document).ready(function ($) {

    $('.bloc_arguments').each(function () {
        const $block = $(this)
        const items = $block.find('.arguments > *').get()
        if (!items.length) return

        gsap.from(items, {
            opacity: 0,
            y: 50,
            ease: "power3.out",
            stagger: 0.3,
            scrollTrigger: {
                trigger: $block[0],
                start: 'top 90%',
                end: 'bottom 98%',
                scrub: .8
            }
        })
    })
})
